var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ButtonBase, CircularProgress, Typography, useMediaQuery, useTheme } from '@mui/material';
import FilterHeading from './filter-heading';
import { useNavigate } from 'react-router-dom';
import useTranslate from '../../../../../localization/helpers';
import { GlobalSearchModule } from '../../../../../application/common/enums/global-search-module';
import { useAppDispatch } from '../../../../../application/store/useStore';
import { setFilePath, setIsOpenDialog } from '../../../../../application/features/global-search/globalSearchSlice';
import { useMemo } from 'react';
import { graphApi } from '../../../../../application/features/microsoft-graph/microsoft-graph-api';
var FileChip = function (_a) {
    var closePopover = _a.closePopover, data = _a.data, count = _a.count, searchTerm = _a.searchTerm, isShowViewAll = _a.isShowViewAll, isInDepth = _a.isInDepth, isLoading = _a.isLoading;
    var theme = useTheme();
    var dispatch = useAppDispatch();
    var translate = useTranslate().translate;
    var navigate = useNavigate();
    var isMd = useMediaQuery(theme.breakpoints.down('lg'));
    var zoomLevel = useMemo(function () {
        return isMd ? 0.2 : 0.8;
    }, [isMd]);
    var handleClick = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var previewUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, graphApi.getPreviewUrl(item.filePath, '1', zoomLevel)];
                case 1:
                    previewUrl = _a.sent();
                    dispatch(setFilePath(previewUrl));
                    dispatch(setIsOpenDialog(true));
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClickAll = function () {
        closePopover && closePopover();
        navigate("/search?query=".concat(searchTerm, "&module=").concat(GlobalSearchModule.Files));
    };
    if (isLoading && isInDepth) {
        return (_jsxs(_Fragment, { children: [_jsx(FilterHeading, { heading: translate('common.indepth'), onButtonClick: function () { return handleClickAll(); }, isShowViewAll: false }), _jsx(Box, { display: 'flex', alignItems: 'center', justifyContent: 'center', p: 4, borderRadius: 2, children: _jsx(CircularProgress, { size: 24, sx: { mr: 2 } }) })] }));
    }
    return count && count > 0 && data && data.length > 0 ? (_jsxs(_Fragment, { children: [_jsx(FilterHeading, { heading: "".concat(count, " ").concat(translate('common.indepth')), onButtonClick: function () { return handleClickAll(); }, isShowViewAll: isShowViewAll }), _jsx(Box, { children: data.map(function (item, index) { return (_jsx(ButtonBase, { onClick: function () { return handleClick(item); }, sx: { width: '100%', textAlign: 'left', borderRadius: '12px' }, children: _jsx(Box, { display: 'flex', flexDirection: 'column', padding: '8px 12px', boxShadow: theme.shadows[4], width: '100%', marginBottom: 1, borderRadius: '12px', children: _jsx(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', alignItems: 'center', children: _jsx(Typography, { variant: 'body2', color: theme.palette.text.primary, dangerouslySetInnerHTML: {
                                    __html: item.fileName
                                } }) }) }, index) }, index)); }) })] })) : (_jsx(_Fragment, { children: isInDepth && (_jsx(FilterHeading, { heading: "".concat(count, "  ").concat(translate('common.indepth')), isShowViewAll: false })) }));
};
export default FileChip;
